import { createSlice } from "@reduxjs/toolkit";
import VwGnlKurumTarifeDTO from "src/models/Settings/Generals/VwGnlKurumTarifeDTO";
import VwKurumDTO from "src/models/Settings/Generals/VwKurumDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class KurumTanimAramaKriterleri {
    searchText?: string = "";
    aktifBool?: boolean = true;
}

interface IKurumTanim {
    kurumEkle?: boolean;
    istisnaEkle?: {
        open: boolean,
        gnlKurumTarifeRecord: VwGnlKurumTarifeDTO
    };
    kurumActiveRow?: VwKurumDTO;
    aramaKriterleri?: KurumTanimAramaKriterleri;
    tarifeEkle?: boolean;
    tarifeActiveRow?: VwGnlKurumTarifeDTO;
    kurumId?: number;
    ayniKaydiGetirmeId?: Array<number>;
    entIslemEkleOpen: boolean;
};

export const KurumTanimSlice = createSlice<IKurumTanim, MapReducerPayloads<IKurumTanim, {
    setKurumEkle?: boolean;
    setIstisnaEkle?: {
        open: boolean,
        gnlKurumTarifeRecord: VwGnlKurumTarifeDTO
    };
    setKurumActiveRow?: VwKurumDTO;
    setAramaKriterleri?: KurumTanimAramaKriterleri;
    setTarifeEkle?: boolean;
    setTarifeActiveRow?: VwGnlKurumTarifeDTO;
    setKurumId?: number;
    setAyniKaydiGetirmeId?: Array<number>;
    setEntIslemEkleOpen: boolean;
}>>({
    name: "KurumTanimState",
    initialState: {
        kurumEkle: false,
        istisnaEkle: {
            open: false,
            gnlKurumTarifeRecord: {}
        },
        kurumActiveRow: new VwKurumDTO(),
        aramaKriterleri: new KurumTanimAramaKriterleri(),
        tarifeEkle: false,
        tarifeActiveRow: new VwGnlKurumTarifeDTO(),
        kurumId: 0,
        ayniKaydiGetirmeId: [],
        entIslemEkleOpen: false,
    },
    reducers: {
        setKurumEkle: (state, action) => {
            state.kurumEkle = action.payload
        },
        setIstisnaEkle: (state, action) => {
            state.istisnaEkle = action.payload
        },
        setKurumActiveRow: (state, action) => {
            state.kurumActiveRow = action.payload
        },
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setTarifeEkle: (state, action) => {
            state.tarifeEkle = action.payload
        },
        setTarifeActiveRow: (state, action) => {
            state.tarifeActiveRow = action.payload
        },
        setKurumId: (state, action) => {
            state.kurumId = action.payload
        },
        setAyniKaydiGetirmeId: (state, action) => {
            state.ayniKaydiGetirmeId = action.payload
        },
        setEntIslemEkleOpen: (state, action) => {
            state.entIslemEkleOpen = action.payload
        },
    }
});